import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { I18nProvider } from "@/contexts/I18nContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { SiteSettingsProvider } from "@/contexts/SiteSettingsContext";

import PublicLayout from "@/components/PublicLayout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import WelcomePage from "@/pages/WelcomePage";
import ServicesPage from "@/pages/ServicesPage";
import WorksPage from "@/pages/WorksPage";
import WorkDetailPage from "@/pages/WorkDetailPage";
import { NewsPage, NewsDetailPage } from "@/pages/NewsPages";
import BrandSectionPage from "@/pages/BrandSectionPage";
import ScrollToTop from "@/components/ScrollToTop";
import ClientsPage from "@/pages/ClientsPage";
import ContactPage from "@/pages/ContactPage";
import BusinessCardPage from "@/pages/BusinessCardPage";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminWorks from "@/pages/admin/AdminWorks";
import AdminNews from "@/pages/admin/AdminNews";
import AdminServices from "@/pages/admin/AdminServices";
import AdminClients from "@/pages/admin/AdminClients";
import AdminBrandItems from "@/pages/admin/AdminBrandItems";
import AdminStats from "@/pages/admin/AdminStats";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminCompanyProfile from "@/pages/admin/AdminCompanyProfile";
import AdminWelcome from "@/pages/admin/AdminWelcome";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminSiteSettings from "@/pages/admin/AdminSiteSettings";
import AdminValues from "@/pages/admin/AdminValues";
import AdminMediaLibrary from "@/pages/admin/AdminMediaLibrary";
import AdminBusinessCards from "@/pages/admin/AdminBusinessCards";

function PublicWrap({ children }) {
    return <PublicLayout>{children}</PublicLayout>;
}

function App() {
    return (
        <SiteSettingsProvider>
            <I18nProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <ScrollToTop />
                    <Toaster position="top-center" richColors closeButton />
                    <Routes>
                        {/* Public */}
                        <Route path="/" element={<PublicWrap><HomePage /></PublicWrap>} />
                        <Route path="/about" element={<PublicWrap><AboutPage /></PublicWrap>} />
                        <Route path="/welcome" element={<PublicWrap><WelcomePage /></PublicWrap>} />
                        <Route path="/services" element={<PublicWrap><ServicesPage /></PublicWrap>} />
                        <Route path="/work" element={<PublicWrap><WorksPage /></PublicWrap>} />
                        <Route path="/work/:slug" element={<PublicWrap><WorkDetailPage /></PublicWrap>} />
                        <Route path="/news" element={<PublicWrap><NewsPage /></PublicWrap>} />
                        <Route path="/news/:slug" element={<PublicWrap><NewsDetailPage /></PublicWrap>} />
                        <Route path="/global-reach" element={<PublicWrap><BrandSectionPage section="media" /></PublicWrap>} />
                        <Route path="/clients" element={<PublicWrap><ClientsPage /></PublicWrap>} />
                        <Route path="/contact" element={<PublicWrap><ContactPage /></PublicWrap>} />
                        <Route path="/card/:slug" element={<BusinessCardPage />} />

                        {/* Admin */}
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminLayout />}>
                            <Route index element={<AdminDashboard />} />
                            <Route path="works" element={<AdminWorks />} />
                            <Route path="news" element={<AdminNews />} />
                            <Route path="services" element={<AdminServices />} />
                            <Route path="clients" element={<AdminClients />} />
                            <Route path="brand/:section" element={<AdminBrandItems />} />
                            <Route path="stats" element={<AdminStats />} />
                            <Route path="users" element={<AdminUsers />} />
                            <Route path="profile" element={<AdminCompanyProfile />} />
                            <Route path="welcome" element={<AdminWelcome />} />
                            <Route path="settings" element={<AdminSiteSettings />} />
                            <Route path="values" element={<AdminValues />} />
                            <Route path="media" element={<AdminMediaLibrary />} />
                            <Route path="contacts" element={<AdminContacts />} />
                            <Route path="business-cards" element={<AdminBusinessCards />} />
                        </Route>

                        {/* 404 fallback */}
                        <Route path="*" element={<PublicWrap><HomePage /></PublicWrap>} />
                    </Routes>
                </BrowserRouter>
                </AuthProvider>
            </I18nProvider>
        </SiteSettingsProvider>
    );
}

export default App;
